import { jsx as _jsx } from "react/jsx-runtime";
import { isNullOrUndefined } from '@as-react/common-utils';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { useProductPlacementCopyBox } from './useProductPlacementCopyBox';
import { Box } from '@yonderland/andes-react';
export const ProductPlacementCopyBoxAlpha = ({ ppc }) => {
    const { content, renderedContainerElement, isExternal } = useProductPlacementCopyBox(ppc);
    if (isNullOrUndefined(content) || content.length === 0)
        return null;
    return (_jsx(Box, { testId: "product_placement_copy", paddingBlock: "2", paddingInline: isExternal()
            ? undefined
            : {
                xs: '4',
                sm: '2',
            }, backgroundColor: isExternal() ? undefined : 'quiet', children: _jsx("div", { ref: renderedContainerElement, children: _jsx(HtmlInclude, { htmlFragment: content }) }) }));
};
